import { SERVICE, POPULATION_TYPE, SortBy, SORTING_DIR } from "@/common/models";

export enum AccountScannedState {
  BOTH = "both",
  SCANNED = "scanned",
  UN_SCANNED = "un_scanned",
}

export interface AccountFilters {
  query: string;
  scanned: AccountScannedState;
  services: SERVICE[];
}

export interface UserAccount {
  type: POPULATION_TYPE.ACCOUNT;
  id: string | number;
  name: string;
  serviceScope: string;
  externalId: string;
  lastSyncAt: string;
  service: SERVICE;
  service_icon: string;
  email: string;
  // scanSync: string;
  isScanned: boolean;
  // runtime
  checked: boolean;
}

export interface AccountsState {
  accounts: UserAccount[];
  hasNoResults: boolean;
  lastCursor: string;
  allAccountsHasLoaded: boolean;
  searchLastCursor: string;
  isCheckedAllAccounts: boolean;
  totalNumOfAccounts: number;
  filters: AccountFilters;
  sortBy: SortBy;
}

export const SEED: AccountsState = {
  accounts: [],
  totalNumOfAccounts: 0,
  hasNoResults: false,
  lastCursor: "",
  searchLastCursor: "",
  allAccountsHasLoaded: false,
  isCheckedAllAccounts: false,
  filters: {
    query: "",
    scanned: AccountScannedState.BOTH,
    services: [],
  },
  sortBy: { key: "name", dir: SORTING_DIR.DESC },
};
